import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=b8d18dba&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=b8d18dba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d18dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8d18dba')) {
      api.createRecord('b8d18dba', component.options)
    } else {
      api.reload('b8d18dba', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=b8d18dba&scoped=true&", function () {
      api.rerender('b8d18dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4dIZo30Cy2dfL/JS/comp/Paginate.vue"
export default component.exports